import type { FC } from 'react'

import { Translation } from '@/app/translations/Translation'

export const ResultCount: FC<{ count: number }> = ({ count }) => {
  if (count === 0) return null

  return (
    <div className="my-1.5 pb-1.5 pt-2">
      <Translation id="Result:" /> {count}
    </div>
  )
}
